import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-nps-form',
  templateUrl: 'nps-form.component.html',
  styleUrls: ['./nps-form.component.scss']
})
export class NPSFormComponent {
  surveyEditor$ = inject(SurveyEditorService).surveyEditor$;
}
